import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { GetStaticProps } from 'next'
import { posthogTracker } from '@/integrations/tracking/posthog/posthogTracker'

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'de', ['common'])),
  },
})

export default function RedirectPage() {
  const router = useRouter()
  const { t } = useTranslation('common')

  useEffect(() => {
    if (!router.isReady) return
    const { to, from } = router.query as { to?: string; from?: string }
    if (!to) return

    // UTM params are auto-captured by PostHog $pageview from the URL
    // Custom event adds destination + origin for funnel analysis
    posthogTracker.sendEvent({ category: 'redirect', object: 'external', action: 'initiated', data: { to, from: from ?? '' } })

    // 300ms to allow PostHog to flush before navigating away
    setTimeout(() => {
      window.location.href = to
    }, 300)
  }, [router.isReady, router.query])

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
      }}
    >
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
      <div
        style={{
          width: 40,
          height: 40,
          border: '3px solid #e5e7eb',
          borderTopColor: '#6b7280',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      <p style={{ margin: 0, color: '#6b7280', fontSize: 16 }}>{t('isRedirecting')}</p>
    </div>
  )
}
